import { useBackdropDismiss } from '../hooks/useBackdropDismiss'
import './ConfirmExitModal.css'

const DEFAULT_TITLE = "⚠️ Quitter l'éditeur"
const DEFAULT_MESSAGE = "Vous allez quitter l'exercice. Les modifications non sauvegardées seront perdues."
const DEFAULT_WARNING = "Assurez-vous d'avoir sauvegardé votre travail avant de quitter."
const DEFAULT_CONFIRM_LABEL = "Quitter sans sauvegarder"

function ConfirmExitModal({
  isOpen,
  onClose,
  onConfirm,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  warning = DEFAULT_WARNING,
  confirmLabel = DEFAULT_CONFIRM_LABEL
}) {
  const backdropDismiss = useBackdropDismiss(onClose)
  if (!isOpen) return null

  return (
    <div className="confirm-exit-modal-backdrop" {...backdropDismiss}>
      <div className="confirm-exit-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-exit-modal-header">
          <h2>{title}</h2>
        </div>

        <div className="confirm-exit-modal-content">
          <p>{message}</p>
          <p className="confirm-exit-modal-warning">{warning}</p>
        </div>

        <div className="confirm-exit-modal-actions">
          <button
            type="button"
            className="confirm-exit-modal-btn cancel-btn"
            onClick={onClose}
          >
            Annuler
          </button>
          <button
            type="button"
            className="confirm-exit-modal-btn confirm-btn"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmExitModal

